import { Observable } from 'rxjs';
import { IGroupedCard } from 'src/app/models/groupedCard';

// dialog.service.ts
export abstract class DialogService {
  abstract openUploadErrorDialog(card: IGroupedCard): Observable<boolean>;
  abstract openMissingTextureMappingDialog(card: IGroupedCard): Observable<boolean>;
}
